import styled, { css } from 'styled-components';
import { primaryColor } from '../../../config/colors';
import Button from '../../Button';

const commonStylesWrapper = css`
  width: 90%;
  max-width: 95%;
  margin: auto;
  background-color: white;
  overflow: hidden;
`;

export const Wrapper = styled.div`
  ${commonStylesWrapper}
  padding: 3rem 2vw 2.5rem 2vw;
  word-break: break-word;
`;

export const TableTitle = styled.span`
  margin-right: 1.25rem;
  font-size: 1.375rem;
  font-weight: 500;
`;

export const SubtypeModuleFamily = styled.span`
  font-size: 1rem;
`;

export const LoaderWrapper = styled.div`
  ${commonStylesWrapper}
  padding: 5rem 0;
`;

export const TextfieldsWrapper = styled.div`
  margin-top: 1rem;
  > *:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-top: 3rem;
  justify-content: flex-end;
  > *:not(:last-child) {
    margin-right: 0.5rem;
  }
`;

export const EditModuleBtn = styled(Button).attrs({
  wrapperStyle: {
    width: 'fit-content',
    height: 'fit-content',
  },
  type: 'transparentBackgroundButton',
  textStyle: {
    color: primaryColor,
    fontSize: '1rem',
  },
})``;

export const Label = styled.span`
  font-size: 0.75rem;
  margin-bottom: ${({ marginBottom }) => marginBottom};
`;

export const CheckboxWrapper = styled.div`
  display:flex;
  align-items:center;
`;
